import "./style.css";
import { useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {  IconButton, ThemeProvider, createTheme } from "@mui/material";
import logo from '../../images/logo.png'
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon  from '@mui/icons-material/FacebookRounded';
import EmailIcon from '@mui/icons-material/AlternateEmailRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Link, useLocation } from "react-router-dom";
import ReactGA from 'react-ga';
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1200,
      lg: 1280,
    },
  },
});

function Header() {
  useEffect(() => {
    const track_id="G-H62WN1HJEK";
  ReactGA.initialize(track_id);
  ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
 

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [activeLink, setActiveLink] = useState("home");



  const location = useLocation();

  const currentPath = location.pathname;

  useEffect(() => {
    setActiveLink(currentPath === "/" ? "home" : currentPath.slice(1));
  }, [currentPath]);
  
  useEffect(() => {
      const pageTitle = location.pathname.split('/').pop();
      if (pageTitle===""){
        // eslint-disable-next-line no-useless-concat
        document.title =  'H4C-creation web'; 
      }else{
      document.title = `${pageTitle.replace(/%20/g, ' ')}`; 
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="header" id="header">
        <a href='/'>
       <img src={logo} alt="logo" className="logo"/>
       </a>
         <div className="nav">
            <ol className={isOpen ? "none" : "linkList"}>
              <li>
                <Link
                  to="/"
                  className={
                    activeLink === "home" ? "navLink active" : "navLink"
                  }
                >
                  ACCUEIL
                </Link>
              </li>
              <li>
                <Link
                  className={
                    activeLink === "services" ? "navLink active" : "navLink"
                  }
                  to="/services"
                >
                  services
                </Link>
              </li>

              <li>
                <Link
                  className={
                    activeLink === "projets" ? "navLink active" : "navLink"
                  }
                  to="/projets"
                >
                  projets
                </Link>
              </li>
              <li>
                <Link
                  className={
                    activeLink === "blog" ? "navLink active" : "navLink"
                  }
                  to="/blog"
                >
                  blog
                </Link>
              </li>
       
          
              <li>
                <div className="socialLinks">
                  <a
                    href="https://www.instagram.com/h4code.tn"
                    target="_blank"
                    rel="noreferrer"
                    className="socialLink"
                  >
                    <InstagramIcon />
                  </a>
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="socialLink"
                  >
                    <FacebookIcon />
                  </a>
                  <a href="mailto:hossjanfaoui.dev@gmail.com" className="socialLink">
                    <EmailIcon />
                  </a>
                  <a href="whatsapp://send?phone=+21622999664" className="socialLink">
                    <WhatsAppIcon />
                  </a>
                </div>
              </li>
            </ol>
          </div>
          <IconButton
            sx={{
              display: {
                lg: "none",
                md: "none",
                sm: "none",
                xs: "inline-block",
              },
              top: 2,
              right: "10px",
              zIndex: 99,
            }}
            onClick={toggleMenu}
          >
            {!isOpen ? (
              <MenuIcon
                id="openIcon"
                sx={{ color: "#008DBD" }}
                fontSize="small"
              />
            ) : (
              <CloseIcon
                id="closeIcon"
                sx={{ color: "#008DBD" }}
                fontSize="medium"
              />
            )}
          </IconButton>
          <div className={isOpen ? "linkMenu show" : "linkMenu"}>
            <ol id="navMenu">
              <li>
                <a
                  className={
                    activeLink === "home" ? "navLink active" : "navLink"
                  }
                  href="/"
                >
                  Accueil
                </a>
              </li>
              <li className="separation"></li>
              <li>
                <a
                  className={
                    activeLink === "services" ? "navLink active" : "navLink"
                  }
                  href="/services"
                >
                  services
                </a>
              </li>
              <li className="separation"></li>
              <li>
                <a
                  className={
                    activeLink === "projets" ? "navLink active" : "navLink"
                  }
                  href="/projets"
                >
                  projets
                </a>
              </li>

              <li className="separation"></li>

              <li>
                <a
                  className={
                    activeLink === "blog"
                      ? "navLink active"
                      : "navLink"
                  }
                  href="/blog"
                >
                  blog
                </a>
              </li>
              <li className="separation"></li>
              <li>
                <div className="socialLinks">
                  <a
                    href="https://www.instagram.com/h4code.tn"
                    target="_blank"
                    rel="noreferrer"
                    className="socialLink"
                  >
                    <InstagramIcon fontSize="small"/>
                  </a>
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="socialLink"
                  >
                    <FacebookIcon fontSize="small"  />
                  </a>
                  <a href="mailto:hossjanfaoui.dev@gmail.com" className="socialLink">
                    <EmailIcon fontSize="small"/>
                  </a>
                  <a href="whatsapp://send?phone=+21622999664" className="socialLink">
                    <WhatsAppIcon fontSize="small" />
                  </a>
                </div>
              </li>
            </ol>
          </div>
        </div>
    </ThemeProvider>
  );
}
export default Header;
